import React, {Fragment} from 'react';
import {connect} from 'react-redux';
import {FormattedMessage, injectIntl} from "react-intl";
import {change} from "redux-form";

import {PARTS} from "../../../schemas/accessRightsModel"
import {AccessRights} from "../../../schemas/accessRightsModel";
import {UI_POPUP_TYPES} from "../../../reducers/R_Popups";
import {loadingDialog_show, setUiPopupState} from "../../../actions/A_Popups";
import {mergePdfWithSignature} from "../../../utilities/pdf/mergeBlobWithImage";
import {saveFabricatorSignedContract} from "../../../actions/fabricator";


const AddACHButton = (props) => {

  const {formValues, setUiPopupState, accountPageInfo, change, loadingDialog_show, AR} = props;
  const {isFabricator, canEditFields, isEmployee, entityId} = accountPageInfo;

  if (!AR.isSiteAdmin && (!canEditFields || !isFabricator || isEmployee) && !AR.e(PARTS.FAB_TOGGLE_ACH_PAYMENTS)) {
    return null
  }

  const onSaveContract = async (closePopup, uiPopupContext) => {
    if (!uiPopupContext.signature) {
      return
    }
    loadingDialog_show(true, 'Saving...', 'Please wait while the contract is saved.');
    change('newEntity', "accountNumber", uiPopupContext.accountNumber);
    change('newEntity', "routingNumber", uiPopupContext.routingNumber);
    try {
      const mergedDoc = await mergePdfWithSignature(uiPopupContext.blob, uiPopupContext.signature);
      const savedDoc = await saveFabricatorSignedContract(mergedDoc, entityId);
      if (savedDoc) {
        const url = URL.createObjectURL(mergedDoc);
        change('newEntity', "achDocumentUrl", url);
      }
      loadingDialog_show(false);
      closePopup();
    } catch (error) {
      console.log("error", error);
      loadingDialog_show(false);
      closePopup();
    }
    // do request on the backend end;
    loadingDialog_show(false, 'Saving...', 'Please wait while the contract is saved.');
    closePopup();
  }

  const openSignModal = () => {
    setUiPopupState({
      headerTextId: "",
      className: "fixed left-0 top-0 scrollbar3",
      style: {maxWidth: "100%", maxHeight: "100%", borderRadius: 0},
      opened: true,
      type: UI_POPUP_TYPES.accountACHContract,
      // context: uiPopupContext, // leave routing numbers as is (in case we need them in the contract)
      buttons: [{}, {
        isSaveButton: true,
        className: "ui-button5 ui-button5--wide text-uppercase ui-button5--green",
        textId: "messageBox.buttons.save",
        onClick: onSaveContract,
      }],
    });
  }

  const openACHCredentialsModal = () => {
    setUiPopupState({
      headerTextId: "account.billingInformation.addACHInfo",
      className: "",
      style: {maxWidth: "540px", maxHeight: "320px"},
      opened: true,
      type: UI_POPUP_TYPES.accountACHCredentials,
      context: {
        accountNumber: formValues.accountNumber || "",
        routingNumber: formValues.routingNumber || "",
        accountNumberMatch: formValues.accountNumber || "",
        routingNumberMatch: formValues.routingNumber || "",
        saveButtonDisabled: !formValues.accountNumber || !formValues.routingNumber, // if no values - disabled
        // fabricatorId: accountPageInfo.entityId
      },
      buttons: [{}, {
        isSaveButton: true,
        className: "ui-button5 ui-button5--wide text-uppercase ui-button5--green",
        textId: "messageBox.buttons.save",
        onClick: (closePopup, uiPopupContext) => {
          if (formValues.accountNumber || formValues.routingNumber) { // doc already signed
            change('newEntity', "accountNumber", uiPopupContext.accountNumber);
            change('newEntity', "routingNumber", uiPopupContext.routingNumber);
            closePopup();
          } else if (uiPopupContext.accountNumber || uiPopupContext.routingNumber) {
            openSignModal(uiPopupContext); // go to sign contract
          } else {
            closePopup(); // just close without saving, the fields are empty
          }
        },
      }],
    });
  }

  return (
    <Fragment>
      <div className="ui-button2 ui-button2--blue mt-1" onClick={openACHCredentialsModal}>
        <FormattedMessage id="account.billingInformation.addACHInfo"/>
      </div>
      {formValues.achDocumentUrl && formValues.achDocumentUrl.trim().length > 0 ? (
        <div className="text-center mt-1">
            <span className="link link--green bold"
                  onClick={() => window.open(formValues.achDocumentUrl, "_blank")}>
            Download Signed Contract
          </span>
        </div>
      ) : null}
    </Fragment>
  )

}

const mapStateToProps = (store) => {

  return {
    accountPageInfo: store.accountState.accountPageInfo,
    formValues: (store.form && store.form.newEntity && store.form.newEntity.values) || {},
    AR: AccessRights.get(store),
  };
};

const mapDispatchToProps = {
  change,
  setUiPopupState,
  loadingDialog_show,
};

export default injectIntl(
  connect(mapStateToProps, mapDispatchToProps)(AddACHButton)
)

